import { Component, Emit, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { VNode } from 'vue';
import { Modal } from 'ant-design-vue';

export interface ModalOptions {
  width?: number | string;
  title?: string;
  cancelText?: string;
  onText?: string;
  // onOk?:OnOkFunc;
  [key: string]: any;
}

// https://stackblitz.com/edit/vuetify-services-plugin-demo?file=services%2FModalService.js
export function openDialog(modalComponent: any, props: any, modalOptions?: ModalOptions) {
  return new Promise((resolve, reject) => {
    const tempComponent = Vue.component('modal-component', {
      data() {
        return {
          showDialog: true,
        };
      },
      components: {
        'x-inner-component': modalComponent,
        'a-modal': Modal,
      },
      methods: {
        dialogResult(data: any) {
          this.showDialog = false;
          resolve(data);
        },
        onOkHandle(e: any) {
          if (modalOptions && modalOptions.onOk) {
            modalOptions.onOk({ resolve, reject, modal: this.$refs.modal, component: this.$refs.innercon });
          } else {
            reject();
            this.showDialog = false;
          }
        },
        onCancelHandle(e: any) {
          if (modalOptions && modalOptions.onCancel) {
            modalOptions.onCancel({ resolve, reject, modal: this.$refs.modal, component: this.$refs.innercon });
          } else {
            resolve();
            this.showDialog = false;
          }
        },
      },
      render(h): VNode {
        const DefaultModalOptions: ModalOptions = {
          width: 800,
          okText: '确定',
          cancelText: '取消',
          okCancel: true,
        };
        modalOptions = Object.assign({}, DefaultModalOptions, modalOptions);

        const { okText, cancelText, okCancel, width } = modalOptions;

        console.log('render:');
        console.log('modalOptions:', modalOptions);
        return (
          <a-modal
            // {...{ props: modalOptions }}
            // {...{
            //   on: {
            //     ok: onOk,
            //     cancel: onCancel,
            //   },
            // }}
            ref="amodal"
            onOk={this.onOkHandle}
            onCancel={this.onCancelHandle}
            visible={this.showDialog}
            cancelText={cancelText}
            okText={okText}
            okCancel={okCancel}
            width={width}
          >
            <x-inner-component ref="innercon" {...{ props: props }}></x-inner-component>
          </a-modal>
        );
      },
    });

    const ModalInstance = new tempComponent();
    ModalInstance.$mount();
  });
}

// export type PluginFunction<T> = (Vue: typeof _Vue, options?: T) => void;
export default function install(vue: typeof Vue, options?: Ch2ComponsePluginOptions): void {
  vue.prototype.$openDialog = openDialog;
}

export class Ch2ComponsePluginOptions {
  // add stuff
}
